/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createComplexClass } from '../../factoriesAny.js';
export var ComplexDependencies = {
  createComplexClass: createComplexClass
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesComplexClass.generated.js
// module id = 39
// module chunks = 0